import TileLayer from 'ol/layer/Tile.js';
import XYZ from 'ol/source/XYZ.js';

class AzureLayer extends TileLayer {
    constructor(options = {}) {

        const merged = {
            name: '',
            key: '',
            layer: 'microsoft.base.road',
            attributions: `© ${new Date().getFullYear()} TomTom, Microsoft`,
            ...options,
        };

        const baseUrl =
            (merged.url || `https://atlas.microsoft.com/map/tile?`) +
            `api-version=2.1&zoom={z}&x={x}&y={y}` +
            `&tileSize=256&language=en-US&tilesetId=${merged.layer}` +
            `&subscription-key=${merged.key}`;

        const source = new XYZ({
            url: baseUrl,
            attributions: merged.attributions,
            crossOrigin: 'anonymous',
        });

        super({ ...merged, source });
        this.set('name', merged.name);
    }
}

export default AzureLayer;
